import React from 'react';
import clsx from "clsx";
import {
    Tabs,
    Paper,
    TextField,
    ClickAwayListener,
    Menu,
    MenuItem
} from "@material-ui/core";
import { 
    ParamsTableContainer,
    TabParams,
} from "../../../styling/Styles"

function TabPanel(props) {
    const { children, value, index } = props;
  
    return (
      <div>
        {value === index && (
            <div>{children}</div>
        )}
      </div>
    );
  }


function ParamsTableHeaders() {
    return (
        <div 
            className={clsx('flex-container')}
            style={{ width: '100%',}}
        >     
            <span
                className= {clsx('lightBlue','flex-container')}
                style={{ justifyContent: 'center', width: '50%'}}
            >
                <span>KEY</span>
            </span>
            <span
                className= {clsx('lightBlue','flex-container')}
                style={{ justifyContent: 'center', width: '50%'}}
            >
                <span>VALUE</span>
            </span>

        </div>    
    )
}

function ParamsTableBody(props) {

    const {
        values,
        handleKeyInput,
        keyId,
        handleValueInput,
        valueId,
        deleteRow
    } = props;
    
    return(
        (   values.length > 0 &&
            values.map( (val,index) => (
                <div 
                    className={clsx('flex-container')}
                    style={{
                        width: '100%'                                        
                    }}
                >
                        <span
                            className={clsx('flex-container')}
                            style={ index%2 === 0 ?{ width: '100%', backgroundColor: '#CFD8E0'}: {width: '100%'}}
                        >
                            <TextField
                                id={keyId}
                                onInput={e => handleKeyInput(e, index)}
                                value={values[index][0]}
                                style={{
                                    width: '100%',           
                                }}
                                placeholder= ' Insert Key'
                            />   
                        </span>    
                        <div>&nbsp;</div>
                        <span
                            className={clsx('flex-container')}
                            style={ index%2 === 0 ?{ width: '100%', backgroundColor: '#CFD8E0'}: {width: '100%'}}
                        >
                        <TextField
                            id={valueId}
                            onInput={e => handleValueInput(e,index)}
                            value={values[index][1]}
                            style={{
                                width: '100%',
                            }}
                            placeholder=' Insert Value'
                        /> 
                        <i className={clsx('fas', 'fa-times-circle', 'teamSelector')} style={{marginTop: '1vh'}} onClick ={() => deleteRow(index)} aria-hidden="true"/>
                        </span>
                        
                </div >  
            ))
        )
    )
}

function AddNewValueButton(props) {

    const {
        buttonfunction,
        isHeaders,
        closeMenu,
        anchorEl,
        clickedAddKey,
        HeaderParams,
        selectHeaderParam
    }=props

    return (
        <>  
            <span 
                className={clsx('teamSelector', 'spacingLeftDiv', 'spacingDownDiv')} 
                onClick={buttonfunction}
                style={{ display: 'inline-block'}}
                aria-hidden="true"
            >
                <span 
                style={{fontSize: '0.7vw'}}
                className={clsx('lightBlue')}>
                    Add new key &nbsp;
                </span>
                { isHeaders === true &&

                    (clickedAddKey === false  ? 
                        <i className={clsx('fa', 'fa-caret-down', 'fa-caret-down3')}> </i>
                        : 
                        <ClickAwayListener 
                            onClickAway ={closeMenu}
                        >
                            <i className={clsx('fa', 'fa-caret-up', 'fa-caret-up3', 'teamSelector')} />
                        </ClickAwayListener>
                    )
                }
                {isHeaders !== true &&
                    <span
                    style={{fontSize: '0.7vw', fontWeight: 'bold'}}
                    className={clsx('lightBlue')}>
                        + 
                    </span>
                }
            </span>
            
            { isHeaders === true &&
                <Menu   
                elevation={0}
                getContentAnchorEl={null} 
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                keepMounted
                open={clickedAddKey}
            >
                {
                    HeaderParams.map((option) => (
                        <MenuItem 
                            key={option}
                            onClick ={() => selectHeaderParam(option)}
                        > 
                            {option}
                        </MenuItem>
                    ))
                }
            </Menu>
            }
        </>
    )
}

const TabsParameters = (props) => {

    const {
        headers,
        setHeaders,
        params,
        setParams,
        bodyParams,
        setBodyParams
    } = props;
    const [value, setValue] = React.useState(0);
    const [clickedAddKey, setClickedAddKey] = React.useState(false);
    const HeaderParams = ['Cookie', 'Content-Length', 'Accept-Encoding', 'User-Agent', 'Connection', 'Accept', 'Accept-Language', 'Host', 'Cache-Control', 'Content-Type', 'Referer', 'Other'];
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleHeaderKeyInput = (val,index) => {
        const tempHeaders = [...headers];
        tempHeaders[index][0] = val.target.value;
        setHeaders(tempHeaders);
    }

    const handleHeaderValueInput = (val,index) => {
        const tempHeaders = [...headers];
        tempHeaders[index][1] = val.target.value;
        setHeaders(tempHeaders);
    }

    const handleParamKeyInput = (val, index) => {
        const tempParams = [...params];
        tempParams[index][0] = val.target.value;
        setParams(tempParams);
    }

    const handleParamValueInput = (val,index) => {
        
        const tempParams = [...params];
        tempParams[index][1] = val.target.value;
        setParams(tempParams);
    }

    const handleBodyParamKeyInput = (val,index) => {
        const tempBodyParams = [...bodyParams];
        tempBodyParams[index][0] = val.target.value;
        setBodyParams(tempBodyParams); 
    } 

    const handleBodyParamValueInput = (val, index) => {
        const tempBodyParams = [...bodyParams];
        tempBodyParams[index][1] = val.target.value;
        setBodyParams(tempBodyParams);
    }

    const openHeaderParams = (event) => {
        
        const tempParams = [...headers];
        tempParams.push(['','']);
        setHeaders(tempParams);
        setClickedAddKey(true);
        setAnchorEl(event.currentTarget);
    }

    const closeMenu = () => {
        setClickedAddKey(false);
        setAnchorEl(null);
    }

    const selectHeaderParam = (option) => {
        const tempHeaders = [...headers];
        if(option !== 'Other'){
            tempHeaders.push([option,'']);
        }
        else{
            tempHeaders.push(['','']);
        }
        setHeaders(tempHeaders);

        setClickedAddKey(false);
        setAnchorEl(null);
    }

    const deleteHeader = (index) => {
        const tempHeaders = [...headers];
        tempHeaders.splice(index, 1);
        setHeaders(tempHeaders);

    }

    const deleteParam = (index) => {
        const tempParams = [...params];
        tempParams.splice(index,1);
        setParams(tempParams);
    }

    const addParams = () => {
        const tempParams = [...params];
        tempParams.push(['','']);
        setParams(tempParams);
    }

    const deleteBodyParam = (index) => {
        const tempBodyParams = [...bodyParams];
        tempBodyParams.splice(index, 1);
        setBodyParams(tempBodyParams);
    }

    const addBodyParams = () => {
        const tempBodyParams = [...bodyParams];
        tempBodyParams.push(['', '']);
        setBodyParams(tempBodyParams);
    }

    return(
        <>
            <Tabs
                value={value}
                onChange={handleChange}
                centered
                TabIndicatorProps={{style: {background:'#E83C52'}}}
            >
                <TabParams   label="Headers"  />
                <TabParams  label="Query Params"/>
                <TabParams  label="Body Params" />
            </Tabs>
            <TabPanel value={value} index={0} >
                <div>
                    <ParamsTableContainer component={Paper}>
                        <ParamsTableHeaders />
                        <div>
                            <ParamsTableBody 
                                values={headers}
                                handleKeyInput={handleHeaderKeyInput}
                                keyId='HeadersKey'
                                handleValueInput={handleHeaderValueInput}
                                valueId='HeadersValue'
                                deleteRow={deleteHeader}
                            />
                            <AddNewValueButton
                                buttonfunction={openHeaderParams}
                                isHeaders='true'
                                closeMenu={closeMenu}
                                anchorEl={anchorEl}
                                clickedAddKey={clickedAddKey}
                                HeaderParams={HeaderParams}
                                selectHeaderParam={selectHeaderParam}
                            />
                            
                        </div>                                  
                    </ParamsTableContainer>
                </div>
            </TabPanel>
            <TabPanel value={value} index={1} >
                <div>
                    <ParamsTableContainer component={Paper}>
                        <ParamsTableHeaders />
                        <div>
                            <ParamsTableBody 
                                values={params}
                                handleKeyInput={handleParamKeyInput}
                                keyId='ParamsKey'
                                handleValueInput={handleParamValueInput}
                                valueId='ParamsValue'
                                deleteRow={deleteParam}
                            />
                            <AddNewValueButton
                                buttonfunction={addParams}
                                isHeaders={false}
                            />

                        </div>
                    </ParamsTableContainer>
                </div>
            </TabPanel>
            <TabPanel value={value} index={2} >
                <div>
                    <ParamsTableContainer component={Paper}>
                        <ParamsTableHeaders />
                        <div>
                            <ParamsTableBody 
                                values={bodyParams}
                                handleKeyInput={handleBodyParamKeyInput}
                                keyId='BodyParamsKey'
                                handleValueInput={handleBodyParamValueInput}
                                valueId='BodyParamsValue'
                                deleteRow={deleteBodyParam}
                            />
                            <AddNewValueButton
                                buttonfunction={addBodyParams}
                                isHeaders={false}
                            />
                        </div>
                    </ParamsTableContainer>
                </div>
            </TabPanel>

        </>
    )
}

export default TabsParameters;
export {
    ParamsTableHeaders, 
    TabPanel,
    ParamsTableBody
}